import { Button } from '../presentation/Button/index.js';
import { ButtonSet } from './ButtonSet.js';
import type { ConfirmationModalProps } from './interfaces';
import { Prompt } from './Prompt.js';
import styles from './style/Base.module.css';

type Props =
    ConfirmationModalProps;

const Confirmation = ({ className = '', ...props }: Props) => {
  const buttons = (
    <ButtonSet>
      <Button.Destructive
        className={styles.promptBtn}
        title="Cancel"
        onClick={props.onClose}
        variant="brick" />
      <Button.Primary
        className={styles.promptBtn}
        title="Confirm"
        onClick={props.onConfirm}
        variant="brick" />
    </ButtonSet>
  );

  return (
    <Prompt
      blocking={props.blocking}
      body={props.body}
      className={className}
      footer={props.footer || buttons}
      header={props.title}
      onClose={props.onClose}
      visible={props.visible} />
  );
};

export { Confirmation };
export default Confirmation;
